module.exports = __webpack_public_path__ + "static/media/pin_oxford_finish.ce704883.png";